var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRvIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,51.6h55.1V39.4c0-4.2,3.4-7.5,7.5-7.5l12.1,0c0.8,0,1.4-0.6,1.4-1.4c0-0.3-0.1-0.6-0.3-0.8l-7-10.1 c-0.5-0.5-1.1-0.9-1.9-0.9l-59.4,0c-7.9,0-7.5,7.7-7.5,7.7V51.6z M56.3,23.3c0-0.7,0.6-1.3,1.3-1.3h8.1c0.2,0,0.5,0.1,0.6,0.3 l3.7,5.3c0.1,0.1,0.1,0.3,0.1,0.4c0,0.4-0.3,0.8-0.7,0.8H57.6c-0.7,0-1.3-0.6-1.3-1.3V23.3z M11.1,30.3c0-0.9,0.7-1.6,1.6-1.6H36 c0.9,0,1.6,0.7,1.6,1.6l0,10.2c0,0.9-0.7,1.6-1.6,1.6H12.7c-0.9,0-1.6-0.7-1.6-1.6L11.1,30.3z M24.4,63.1c-5,0-9,4-9,9c0,5,4,9,9,9 c5,0,9-4,9-9S29.4,63.1,24.4,63.1z M24.4,76c-2.2,0-3.9-1.7-3.9-3.9c0-2.2,1.7-3.9,3.9-3.9c2.2,0,3.9,1.7,3.9,3.9 C28.3,74.3,26.6,76,24.4,76z M97.2,61.8v-5.3c0-2.1-1.4-4-3.2-4.6l-4.6-1.5l-9.2-13.2c-0.5-0.5-1.1-0.9-1.9-0.9H63.8 c-2.4,0-4.3,1.9-4.3,4.3l0,15.5H0v11.2c0,1.6,1.3,2.9,2.9,2.9h7.9c0.4-6.5,7-11.7,13.6-11.7S37.6,63.6,38,70.1h29.2 c0.5-6.5,7-11.6,13.6-11.6c6.6,0,13.1,5.1,13.6,11.6H97c1.6,0,3-1.3,3-2.9v-5.4H97.2z M83.6,53.3l-15.5,0c-1.4,0-2.5-1.1-2.5-2.5v-8 c0-1.4,1.1-2.5,2.5-2.5h8.5c0.4,0,0.8,0.2,1.1,0.5l7.1,10.3c0.2,0.2,0.3,0.5,0.3,0.8C85,52.6,84.4,53.3,83.6,53.3z M80.8,63.3 c-5,0-9,4-9,9c0,5,4,9,9,9c5,0,9-4,9-9C89.8,67.3,85.8,63.3,80.8,63.3z M80.8,76.2c-2.2,0-3.9-1.7-3.9-3.9c0-2.2,1.7-3.9,3.9-3.9 c2.2,0,3.9,1.7,3.9,3.9C84.7,74.5,82.9,76.2,80.8,76.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRvIco);
export default __webpack_public_path__ + "static/media/rvIco.1a2f9db843b5b642324626ba486de9dd.svg";
export { ForwardRef as ReactComponent };